import { objectWithoutProperties as _objectWithoutProperties } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundedProvider } from './ErrorBoundedProvider.js';
import { ChakraUIProvider } from './ChakraUIProvider.js';
var _excluded = ["children", "theme"];

/**
 * Root provider for everything we need to wrap our apps.
 *
 * @returns Wrapped React components or routes
 */
var RootProvider = function RootProvider(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ChakraUIProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(ErrorBoundedProvider, props, children));
};
RootProvider.displayName = "RootProvider";
RootProvider.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object
};
export { RootProvider };